module.exports = __webpack_public_path__ + "static/media/ico_line.04fe5a82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Contacts/imgs/ico_line.svg
// module id = 1684
// module chunks = 0